import { render, staticRenderFns } from "./obatvit.vue?vue&type=template&id=ff734eac&"
import script from "./obatvit.vue?vue&type=script&lang=js&"
export * from "./obatvit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports